export interface UserInfo {
    email: string;
    nom: string;
    prenom: string;
    entrepriseNom: string;
    tokenExpirationDate: string;
    externalLinks: ExternalLink[];
    phoneNumber: string;
    politiqueConfidentialiteAccepted?: boolean;
    politiqueConfidentialiteAcceptedDate?: string;
}
export interface ExternalLink {
    system: string; 
    external_dossier_id: string;
}